'use client'

import { DependencyList, useEffect, useRef } from 'react'

type IdleCallbackHandle = number

interface IdleCallbackOptions {
  timeout?: number

  // Artificial delay option so we can control sequencing of actions
  delay?: number
}

const useIdleObserver = (callback: () => void, options: IdleCallbackOptions = {}, dependencies: DependencyList = []) => {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const idleCallback =
      window.requestIdleCallback ||
      function (cb: () => void, opts?: IdleCallbackOptions) {
        return setTimeout(cb, opts?.timeout || 1)
      }

    const handle: IdleCallbackHandle = idleCallback(() => {
      if (options.delay) {
        setTimeout(() => {
          callbackRef.current()
        }, options.delay)
      } else {
        callbackRef.current()
      }
    }, options)

    return () => {
      if (window.cancelIdleCallback) {
        window.cancelIdleCallback(handle)
      } else {
        clearTimeout(handle)
      }
    }
  }, [dependencies, options])
}

export default useIdleObserver
